import React from "react";
import {Box, BoxProps} from "@mui/material";

export default function ContentBox({sx, children, ...rest}: BoxProps) {
    return (
        <Box
            sx={{margin: "auto 0", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", ...sx}}
            {...rest}
        >
            {children}
        </Box>
    );
}
